const baseColors = {
  /** Brand cream — primary text & icons on dark backgrounds */
  white: "#F2E8CF",
  black: "#1C1C1B",
  transparent: "transparent",

  grey20: "#F9F6F9",
  grey40: "#EEE6ED",
  grey90: "#1C1C1B",

  teal30: "#8298b0",
  teal40: "#afc5d9",

  greyBlue30: "#8ea2b7",
  green50: "#689778",
  sand50: "#F2E8CF",
  grey50: "#CCCCCC",
};

const themeColors = {
  ...baseColors,
  primary: baseColors.green50,
  primaryActive: baseColors.green50,
  primaryDisabled: baseColors.grey90,

  secondary: baseColors.sand50,
  secondaryActive: baseColors.sand50,
  secondaryDisabled: baseColors.sand50,

  bgColor: baseColors.black,
  secondaryBgColor: baseColors.grey90,

  fgColor: baseColors.sand50,
  secondaryFgColor: baseColors.sand50,

  accent: baseColors.green50,
};

const colors = {
  ...themeColors,
};

export default colors;
